import "assets/scss/material-dashboard-pro-react.scss";

// import * as Sentry from "@sentry/react";

import App from "./wisene/components/App/App";
// import { Integrations } from "@sentry/tracing";
import React from "react";
import { render } from "react-dom";
import { IS_DEV_ENVIRONMENT, DEV_BACKGROUND_COLOR } from "./wisene/helpers/environment";

if (IS_DEV_ENVIRONMENT) {
  document.body.style.backgroundColor = DEV_BACKGROUND_COLOR;
}

// Sentry.init({
//     dsn: "https://6fba99269a7940d4946debe97ba14124@o455598.ingest.sentry.io/5447354",
//     integrations: [
//         new Integrations.BrowserTracing(),
//     ],

//     // We recommend adjusting this value in production, or using tracesSampler
//     // for finer control
//     tracesSampleRate: 1.0,
// });

// Supress console.log in production
if (process.env.NODE_ENV !== "development") {
  console.log = () => { };
}

render(<App />, document.getElementById("root"));
